<div style="page-break-inside: avoid;" *ngIf="motorCar?.length" class="mt-4" [ngClass]="{'container': !isSinglePageReturn, 'return-view-background-print': !isSinglePageReturn && printActive, 'return-view-background': !isSinglePageReturn && !printActive}">
    <div class="row mb-4">
        <div class="col-12 text-center">
            <strong>PARTICULARS OF MOTOR CAR</strong><br/>
            <i>[Attachment for serial no 8(g) of IT-10B (2023)]</i>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6"><strong>Taxpayer Name:</strong> {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-6 text-right">
           <strong>Assessment Year:</strong> {{returnData?.submissionInfo?.assessmentYear}}
        </div>
    </div>
    <div class="row mt-3 mb-5">
        <div class="col-sm-12">
            <strong>TIN</strong>&ensp;&ensp;
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>
        </div>
    </div>

    <div *ngIf="motorCar?.length" style="page-break-inside: avoid" class="row mb-4">
        <div class="col-12 text-center mb-3 font-weight-bold">
            Motor Car
        </div>
        <div class="col-12">
            <table class="table table-bordered">                
                <tbody>
                    <tr>
                        <td class="text-center" colspan="2">Registration No.</td> 
                        <td class="text-center">Type of vehicle</td>
                        <td class="text-center">Type of Acquisition</td>
                        <td class="text-center">Engine capacity</td> 
                        <td class="text-center">Value</td>                  
                    </tr> 
                    <tr *ngFor="let item of motorCar; let i = index">
                        <td class="text-center">{{i+1}}</td> 
                        <td class="text-start">{{item?.relatedIN}}</td> 
                        <td class="text-start pr-3">{{getMotorcarTypeDescription(item?.description)}}</td> 
                        <td class="text-start pr-3">{{item?.type}}</td>
                        <td class="text-start pr-3">{{item?.otherInfo}} {{item?.name}}</td> 
                        <td class="text-right pr-3">{{item?.value | currencySeparatorBD}}</td>            
                    </tr>                                
                </tbody>
            </table>
        </div>
    </div>
</div>
